class MedicamentoTabelaAbcFarmaController extends AbstractController
  @$inject = [ '$injector', '$scope', 'pathService', 'estadoService', 'medicamentoTabelaAbcFarmaService' ]

  constructor: ($injector, @scope, pathService, @estadoService, @medicamentoTabelaAbcFarmaService) ->
    super($injector)

    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/desvios-st/tabs/farmaceutico/tabela-abc-farma/"
    @loadingTracker = @promiseTracker()

    @filtro =
      page: 1
      codigoBarras: ''
      descricao: ''

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @listOfMedicamentoTabelaAbcFarma = []
    @listOfEstado = []

    @loadingTracker.addPromise @estadoService.getList((data) =>
      @listOfEstado = data
    )

  loadData: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    @loadingTracker.addPromise @medicamentoTabelaAbcFarmaService.getList(filtro, (result) =>
      if result.success
        @listOfMedicamentoTabelaAbcFarma = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar as tabelas de medicamentos da ABC FARMA.', 'Erro!', false)
    )

angular.module('eficienciaFiscalModule').controller('medicamentoTabelaAbcFarmaController', MedicamentoTabelaAbcFarmaController)
